import LoadingGif from '../../../assets/loading.gif';
import './style.scss';

const PageLoader = () => {
    return  <>
        <div className="page-is-loading">
            <img src={LoadingGif} />
        </div>
    </>
}

export default PageLoader;